import { useEffect, useState } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Router from './routes/router';
import ActiveUser from './component/common/userTrack/index';
// import Analytics from './component/common/userTrack/analytics';
import { PricingProvider } from './website/views/checkout/cart/PricingProvider';
import { initPricingConfig } from './helper/constants';
import { setNavigate } from './service/navigationService';
import { MappingNotificationProvider } from './base/context/MappingNotificationProvider';

import './App.css';
import './assets/colors/color.css';

function NavigationSetter() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  return null;
}

function App() {
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    initPricingConfig().then(() => setConfigLoaded(true));
  }, []);

  if (!configLoaded) {
    return null; // Or a loading spinner
  }

  return (
    <HelmetProvider>
      <BrowserRouter>
        <NavigationSetter />
        {/* <Analytics /> */}
        <MappingNotificationProvider>
          <PricingProvider>
            <ActiveUser>
              <Router />
            </ActiveUser>
          </PricingProvider>
        </MappingNotificationProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
